import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ApptextsComponent} from './apptexts.component';

const routes: Routes = [
  {path: 'apptexts', component: ApptextsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class ApptextsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/apptexts/apptexts-routing.module.ts